"use client"

import { usePathname } from "next/navigation"
import { ChevronLeft } from "lucide-react"
import { navigateUrl } from "@/utils/client-request"
import { formatImageURL, getActiveBanners, getFontClass } from "@/utils/util"

const focusRing = 'focus-visible:outline-1 focus-visible:outline-offset-4 focus-visible:outline-foreground'

export default function AuthLayout({ children, vendor }: { children: React.ReactNode, vendor?: any }) {
  const pathname = usePathname() || ''
  const banner = getActiveBanners(vendor?.banners || [])[0]
  const fontClass = getFontClass(vendor?.font)

  return (
    <div className={`min-h-svh lg:grid lg:grid-cols-2 bg-background text-foreground ${fontClass}`}>
      <div className="hidden lg:block relative bg-muted overflow-hidden">
        {banner?.image ? (
          <>
            <img src={formatImageURL(banner.image)} alt="" className="absolute inset-0 w-full h-full object-cover" />
            <div aria-hidden className="absolute inset-0 bg-black/20" />
          </>
        ) : (
          <div className="absolute inset-0 flex items-end p-12">
            <span className="text-5xl tracking-tight text-foreground/80">{vendor?.name}</span>
          </div>
        )}
      </div>

      <div className="min-h-svh flex flex-col px-6 sm:px-12">
        <div className="h-20 shrink-0 flex items-center justify-between gap-4">
          <a href={navigateUrl('/', pathname)} className={`flex items-center min-w-0 ${focusRing}`}>
            {vendor?.logo ? (
              <img src={formatImageURL(vendor.logo)} alt={vendor?.name || 'logo'} className="h-7 w-auto max-w-40 object-contain" />
            ) : (
              <span className="text-lg tracking-tight truncate">{vendor?.name}</span>
            )}
          </a>
          <a href={navigateUrl('/', pathname)} className={`inline-flex items-center gap-1.5 text-[13px] transition-opacity duration-150 hover:opacity-60 ${focusRing}`}>
            <ChevronLeft className="size-4" strokeWidth={1.5} />
            Буцах
          </a>
        </div>

        <div className="flex-1 flex items-center justify-center py-10">
          <div className="w-full max-w-sm">{children}</div>
        </div>

        <div className="h-16 shrink-0 flex items-center justify-center text-xs text-muted-foreground">
          <a href="https://shop.mn" target="_blank" rel="noopener noreferrer" className={`transition-colors duration-150 hover:text-foreground ${focusRing}`}>Онлайн худалдааны шийдэл · Shop.mn</a>
        </div>
      </div>
    </div>
  )
}
